import styled from 'styled-components';

import { Button } from '../../Button';

export const StyledContainer = styled.div`
  margin: 2px 0 0;
`;

export const StyledButton = styled(Button)`
  width: fit-content;
`;
